import { ProviderType } from "../../../services/cloudchipr.api";

export const providers: ProviderType[] = ["aws", "azure", "gcp"];

export const isStringProviderType = (str: string): str is ProviderType => {
  return providers.includes(str as ProviderType);
};
